import UnitPrice from "@/accounting/domain/models/unit-price";
import PurchaseOrder from "@/accounting/domain/models/purchase-order";
import PurchaseOrderItem from "@/accounting/domain/models/purchase-order-item";
import PurchaseOrderItems from "@/accounting/domain/models/purchase-order-items";

export function toPurchaseOrder(data: any): PurchaseOrder {
  return new PurchaseOrder(
    data.id,
    data.projectId,
    data.projectName,
    data.staffName,
    data.title,
    data.mention,
    data.status,
    data.statusName,
    data.estimateId,
    data.estimateTaxRate,
    data.vendorId,
    data.vendorName,
    data.taxRate,
    toPurchaseOrderItems(data.items),
    Boolean(data.printsExcludeTax),
    data.issuedAt,
    data.dateOfIssue,
    data.purchaseNumber,
    data.estimateNumber,
    data.deliveryDate
  );
}

export function toPurchaseOrderItems(data: any[]): PurchaseOrderItems {
  if (data.length > 0) {
    return new PurchaseOrderItems(...data.map(toPurchaseOrderItem));
  }
  return new PurchaseOrderItems();
}

export function toPurchaseOrderItem(data: any): PurchaseOrderItem {
  const items = toPurchaseOrderItems(data.items);
  const loss = data.items.length
    ? new UnitPrice(items.totalLoss)
    : new UnitPrice(data.unitLoss || 0);

  return new PurchaseOrderItem(
    data.id,
    data.estimateId,
    data.unitName,
    data.unitType,
    new UnitPrice(data.unitPrice),
    loss,
    data.amount,
    data.memo,
    items
  );
}
